import Container from '@/components/Container';

const LeadershipWheelSkeleton = () => {
  return (
    <div className={`mt-sh-30 w-full animate-pulse px-6`}>
      <Container>
        <div className="col-span-12 flex flex-col items-center gap-4">
          <div className="mb-sh-30 h-[1rem] w-full max-w-[200px] animate-pulse bg-gray-300"></div>
          <div className="h-[320px] w-[320px] animate-pulse rounded-full bg-gray-300 py-1"></div>
          <div className="mt-sh-30 h-[1rem] w-full max-w-[200px] animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-full max-w-[250px] animate-pulse bg-gray-300 "></div>
          <div className="h-[1rem] w-full max-w-[200px] animate-pulse bg-gray-300 "></div>
        </div>
      </Container>
    </div>
  );
};

export default LeadershipWheelSkeleton;
